import { memo, useCallback } from 'react';
import cn from 'classnames';
import { CONTENT_SUB_TYPE, CONTENT_TYPE, PLACE_HOLDER } from 'src/constants';
import { Element } from 'src/components';
import { CONTENT_MAP } from '..';
import ContentText, { ITextProps } from '.';
import styles from '../style.module.scss';
export interface IBodyBlockProps extends ITextProps {
    childs: ITextProps[];
}

const BodyBlock = (props: IBodyBlockProps) => {
    const { childs = [], index, contentId, ...blockProps } = props;
    const hasTextType = childs.some((item) => item.type === 'text');
    const childImgs = childs.filter((item) => item.type === 'image');
    const isNormalBlock = hasTextType || childs.length === 0;

    const removeBodyBlockClass = (type: string = '') => {
        return type.replace(CONTENT_SUB_TYPE.BODY_BLOCK, '');
    };

    const renderChild = (props: any, i: number) => {
        const Comp = CONTENT_MAP[props.type];
        if (!Comp) {
            return null;
        }

        let currentIndex = i + index;

        if (props.type === CONTENT_TYPE.VIDEO) {
            let _props = {
                ...props,
                contentId,
                index: currentIndex,
                id: `block_item_${i}`,
            };
            return (
                <Element
                    key={`content.type.block.${i}`}
                    style={{
                        width: 'calc(100vw - 72px)',
                        maxWidth: 586,
                        height: `calc((100vw - 72px) * ${
                            (props.height || 9) / (props.width || 16)
                        })`,
                        maxHeight: '80vh',
                        background: `url(${PLACE_HOLDER.VIDEO}) no-repeat center center`,
                        backgroundSize: 'cover',
                        position: 'relative',
                    }}
                >
                    <Comp {..._props} />
                </Element>
            );
        }

        return (
            <Comp
                {...props}
                contentId={contentId}
                index={currentIndex}
                key={`block_item_${i}`}
                subType={removeBodyBlockClass(props.subType)}
            />
        );
    };

    const renderChildren = useCallback(() => {
        return childs.map((props, i) => renderChild(props, i));
    }, [props]);

    const renderBody = useCallback(() => {
        if (childs.length) {
            return renderChildren();
        }
        return (
            <ContentText
                {...blockProps}
                contentId={contentId}
                index={index}
                subType={removeBodyBlockClass(blockProps.subType)}
            />
        );
    }, [props]);

    return (
        <Element
            className={cn(styles['body-block'], {
                ['p-[20px] bg-[#eef8f9]']: isNormalBlock,
                'image-wrapper !leading-[1.5]': childImgs.length >= 2,
            })}
        >
            {renderBody()}
        </Element>
    );
};

export default memo(BodyBlock);
